<template>
    <div class="create-post__wrapper">
        <!-- For desktops -->
        <v-container fluid v-if="isDesktop">
            <form-post @photosAdded="managePhotos" @deletePhoto="deletePhoto" @formValidated="sendPost" :users="users" :photos="photos" 
            :loading="postCreating" @updatePhoto="updatePhoto"></form-post>
        </v-container>
        <!-- For mobiles steppers -->
        <v-container fluid v-else>
            <form-post-mobile @photosAdded="managePhotos" @deletePhoto="deletePhoto" @formValidated="sendPost" :users="users" :photos="photos" :showBottomBar="showBottomBar" :bottomBar="bottomBar" :loading="postCreating" @updatePhoto="updatePhoto"></form-post-mobile>
        </v-container>
    </div>
</template>
<script>
import formMobile from "@/components/forms/form-post-create-mobilestepper.vue"
import formPostCreate from "@/components/forms/form-post-create.vue"
import fileMixins from "@/mixins/mixin-files"

import {
    DEL_FILE,
    CREATE_POST
} from "@/store/actions.type"

import {
    UPDATE_FILE
} from "@/store/mutations.type"

import {
    POST_UPLOADS
} from '@/store/media.type'


export default {
    components: {
        "form-post": formPostCreate,
        "form-post-mobile": formMobile
    },

    mixins: [fileMixins],

    data: () => ({
        bottomBar: false,
        users: [],
        tags: []
    }),

    mounted() {
        this.$nextTick(() => {
            // Enter bar on Mobile for smoother reveal
            if (!this.isDesktop) {
                this.bottomBar = true
            }
        })
    },

    /* eslint-disable */
    beforeRouteLeave(to, from, next) {
        // on route change disablling bar for smoother transitions
        if (!this.isDesktop && this.bottomBar) {
            this.bottomBar = false
            setTimeout(next, 200)
        } else {
            next()
        }
    },

    computed: {
        // Get all photos of the post
        photos() {
            return this.$store.getters.getPhotos(POST_UPLOADS)
        },

        // creating flag
        postCreating() {
            return this.$store.state.post.creatingPost
        },

        // Show bottom bars on mobile
        showBottomBar() {
            return !this.isDesktop
        }
    },

    methods: {
        /* 
         * Photo handlers
         */
        managePhotos(files) {
            // On upload media event
            this.fileUploads(files, POST_UPLOADS)
        },

        deletePhoto(id) {
            // on delete media event
            this.$store.dispatch(DEL_FILE, id)
        },

        /* 
         * Form Handlers
         */
        sendPost(formData) {
            if (formData) {
                this.$store.dispatch(CREATE_POST, {
                    ...formData,
                    attachments: this.photos.filter(photo => photo.uploaded === true)
                })
            }
        },
        /* 
         * Updating Photo
         */
        updatePhoto(payload) {
            this.$store.commit(UPDATE_FILE, payload)
        }
    }
}
</script>